import axios from "axios";
import qs from "qs";
import {
	Loading
} from 'element-ui';
const install = Vue => {
	Vue.prototype.apis = {
		// 接口
		// banner:'api/Index/banner_list'

	};
	//声明一个loading空变量
	let loadingIsShow = null;
	// 新创建一个axios实例，并进行基础配置
	var instance = axios.create({
		// 本地为空，请求发到当前页面并由 vue.config.js 代理到后端；打包后使用线上地址
		baseURL: process.env.VUE_APP_API_BASE || "",
		timeout: 7000,
		withCredentials: true,	// 安全整改：跨域请求携带会话Cookie，配合后端登录拦截器
		headers: {
			// "Content-Type": "application/x-www-form-urlencoded",
			'content-type': 'application/json',
		}
	});

	// 添加请求拦截器
	instance.interceptors.request.use(config => {
		// 再次设置tkoen或者添加loading等请求前的操作
		// 添加一个loading
		loadingIsShow = Loading.service({
			lock: true,
			text: "Loading",
			spinner: "el-icon-loading",
			background: "rgba(0, 0, 0, 0.7)"
		});
		return config;
	});

	// // 添加xi响应拦截器
	instance.interceptors.response.use(
		response => {
			//响应数据后做点什么
			// 请求成功关闭loading
			// console.log("请求成功");
			loadingIsShow.close();
			return response;
		},
		error => {
			if (loadingIsShow) {
				loadingIsShow.close();
				loadingIsShow = null;
			}
			return Promise.reject(error);
		}
	);

	Vue.prototype.api = function(url, params = {}) {
		const that = this;
		var userId= localStorage.getItem('userId');
		const isLoginRequest = typeof url === "string" && url.indexOf("/admin/login") !== -1;
		if(userId!=null&&userId!=undefined&&userId!=''){
			params.userId=Number(userId);
		}else if (!isLoginRequest) {
			// 未登录不请求受保护接口。否则一进首页就会打 menuList，401 时加载层关不掉
			if(!this.$route || this.$route.name !== "log"){
				that.$router.replace({name:'log'})
			}
			return Promise.resolve({ code: 401, msg: "请先登录" });
		}
		return new Promise((resolve, reject) => {
			instance
				.post(url, params)
				.then(res => {
					// 安全整改：未登录/会话过期统一跳回登录页
					if (res.data.code == 401) {
						localStorage.removeItem("userId");
						that.$message(res.data.msg || "请先登录");
						if (that.$route.matched[0].path != '/log') {
							that.$router.replace({ name: 'log' });
						}
						resolve(res.data);
						return;
					}
					if (res.data.code != 200) {
						 this.$message(res.data.msg);
					}
					// else if (res.data.status == -200) {
					// 	localStorage.removeItem("token");
					// 	that.$router.replace({
					// 		name: 'log'
					// 	})
					// }
					resolve(res.data);
				})
				.catch(error => {
					const status = error.response && error.response.status;
					if (status === 401) {
						localStorage.removeItem("userId");
						if (!that.$route || that.$route.name !== "log") {
							that.$router.replace({ name: "log" });
						}
						resolve({ code: 401, msg: "请先登录" });
						return;
					}
					reject(error);
				});
		});
	};
};
export default install;
